import React from "react";
import {
  Col,
  CardBody,
  Card,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import client from "../../../../../../shared/api-client";
import toQueryString from "../../../../../../shared/toQueryString";
import Modal from "../../../../../../shared/modal";
import FormComponent from "./AddCredit";
import Slider from "react-slide-out";
import * as CurrencyFormat from "react-currency-format";
import * as users from "../../../../../../shared/service/users";

class SalesStatistic extends React.Component {
  state = {
    isOpen: false,
    show: false,
    credit: 0,
    dropdownOpen: false,
    add: true,
  };

  getProfileStats = () => {
    let params = toQueryString({
      uid: this.props.id,
    });

    client(`user_statics.php?${params}`).then((response) => {
      this.getUseCases();
      this.setState(response);
    });

    users.getProfile(this.props.id).then((response) => {
      this.setState(response);
    });
  };

  getUseCases = () => {
    client(`proxy_usage.php`).then(
      (response) => {
        let useCases = [];

        response.data.forEach((usecase) => {
          useCases.push({
            value: usecase.slug,
            label: usecase.name,
          });
        });

        useCases.push({
          value: "Other",
          label: "Other",
        });
        this.setState({ useCases });
      },
      (error) => {
        console.error(error);
      }
    );
  };

  componentDidMount() {
    this.getProfileStats();
  }

  toggleAddNew = (add) => {
    this.setState((prevState) => ({ isOpen: !prevState.isOpen, add: add }));
  };

  handleForm = (formValues) => {
    this.setState({ formValues });
  };

  submitForm = () => {
    let body = this.state.formValues;
    body.uid = this.props.id;

    if (body.credits <= 0) {
      this.setState({
        show: true,
        errors: ["Credits can't be zero or negative"],
      });
    } else {
      body.credits = this.state.add ? body.credits : -1 * body.credits;

      client(`billing_topup.php`, {
        method: "PUT",
        body: body,
      }).then(
        (response) => {
          this.getProfileStats();
          this.toggleAddNew();
        },
        (error) => {
          this.setState({ show: true, errors: error._user_message });
        }
      );
    }
  };

  showModal = (e) => {
    this.setState({
      show: !this.state.show,
    });
  };

  toggle = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  };

  render() {
    return (
      <React.Fragment>
        <Col md={12} lg={12} xl={12}>
          <Card className="dashboard">
            <CardBody className="profile__information ">
              <div className="floatLeft">
                <h5 className="bold-text">CREDITS</h5>
              </div>
              <div className="floatRight">
                <ButtonDropdown
                  isOpen={this.state.dropdownOpen}
                  toggle={this.toggle}
                >
                  <DropdownToggle
                    caret
                    color={this.state.credit >= 0 ? "primary" : "danger"}
                    className={
                      this.state.credit >= 0
                        ? "btn btn-sm btn-primary"
                        : "btn btn-sm btn-danger"
                    }
                  >
                    <CurrencyFormat
                      value={this.state.credit}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={"$"}
                    />
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem onClick={() => this.toggleAddNew(true)}>
                      Add Credit
                    </DropdownItem>
                    <DropdownItem onClick={() => this.toggleAddNew(false)}>
                      Remove Credit
                    </DropdownItem>
                  </DropdownMenu>
                </ButtonDropdown>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col md={12} lg={12} xl={12}>
          <Card className="dashboard">
            <CardBody className="profile__information ">
              <label>Account Manager : </label> {this.state.account_manager}
              <br />
              <label>Lead Score : </label> {this.state.lead}
              <br />
              <label>Lead Stage : </label> {this.state.lead_stage}
              <br />
              <label>Onboarding Status : </label> {this.state.onboarding_status}
              <br />
              <label>Utm : </label> {this.state.utm}
              <br />
              <label>Suspend : </label> {this.state.suspend}
            </CardBody>
          </Card>
        </Col>
        <Col md={12} lg={12} xl={12}>
          <Card className="dashboard">
            <CardBody className="profile__information ">
              <label>Usage : </label> {this.state.use_proxy_for}
              <br />
              <label>Websites : </label> {this.state.proxy_website_usage}
              <br />
              <label>Estimated Bandwidth usage/month : </label>{" "}
              {this.state.estimated_quota}
              <br />
              <label>Products Interested : </label>{" "}
              {this.state.products_interested}
              <br />
              <label>Project Requirements : </label> {this.state.comments}
            </CardBody>
          </Card>
        </Col>
        <Slider
          isOpen={this.state.isOpen}
          footer={
            <div className="button-container">
              <button
                className="square btn btn-primary btn-sm"
                onClick={this.submitForm}
                type="button"
              >
                Submit
              </button>
              <button
                type="button"
                className="square btn btn-danger btn-sm"
                onClick={() => this.toggleAddNew()}
              >
                Cancel
              </button>
            </div>
          }
          onOutsideClick={() => this.setState({ isOpen: false })}
        >
          {
            <FormComponent
              title={this.state.add ? "Add Credit" : "Remove Credit"}
              add={this.state.add}
              useCases={this.state.useCases}
              handleForm={(formValues) => this.handleForm(formValues)}
            />
          }
        </Slider>
        <Modal
          onClose={this.showModal}
          show={this.state.show}
          errors={this.state.errors}
        ></Modal>
      </React.Fragment>
    );
  }
}

export default SalesStatistic;
